"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
exports.default = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexGrow: 1,
        minWidth: 200,
        maxWidth: '100%',
        appearance: 'none',
        boxSizing: 'border-box',
        outline: 'none',
        border: `1px solid ${theme.grey5}`,
        backgroundColor: theme.grey9,
        borderRadius: 2,
        flexShrink: 0,
        cursor: 'default',
        height: constants_1.MIN_TARGET_SIZE + 2,
        paddingLeft: 7,
        paddingRight: 7,
        fontSize: 14,
        fontWeight: 400,
        color: theme.grey1,
        zIndex: 10,
        transition: 'border-color 150ms linear 0ms',
        '&[disabled]': {
            opacity: 0.3
        },
        '&[data-is-invalid="true"]': {
            borderColor: theme.warningRed
        },
        '&[data-has-value="false"]': {
            color: theme.grey4
        },
        '&[data-is-open="true"]': {
            borderTop: `1px solid ${theme.indigo3}`,
            borderLeft: `1px solid ${theme.indigo3}`,
            borderRight: `1px solid ${theme.indigo3}`,
            '&[data-is-invalid="true"]': {
                borderColor: theme.warningRed,
                borderBottom: `1px solid ${theme.grey5}`
            }
        }
    },
    value: {
        flexGrow: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    icon: {
        color: theme.grey3,
        transform: 'rotate(0deg)',
        transition: 'transform 0.3s ease-in-out',
        '&[data-is-open="true"]': {
            transform: 'rotate(180deg)'
        }
    }
});
//# sourceMappingURL=select.button.style.js.map